export default {
  menu: {
    sports: "Sports",
    referAndEarn: "Refer and Earn",
    referDesc: "up to 60% commission",
    copyLink: "Copy Link",
    hot: "Hot",
    favorites: "Favorites",
    recent: "Recent",
    vipClub: "VIP Club",
    bonus: "Bonus",
    bonusGames: "Bonus Games",
    affiliate: "Agent",
    promotion: "Promotions",
    rewards: "Rewards",
    help: "Help",
    feedback: "Feedback",
    downloadApp: "Download App",
    claimBonus: "Claim Bonus",
    redeemCode: 'Redeem Code',
    redeemDesc: 'Claim Your Free Reward',
    liveSupport: "Customer Service",
    language: "Language",
	search: "search"
  }
}
